import { useState } from "react";

import NumberInputText from "../../controls/inputs/NumberInputText";
import Button from "../../controls/Button";

export default function AddPriceGroupModal(props) {
  const { createPriceGroup, setEmptyModelOpen } = props;

  const [amount, setAmount] = useState(0);
  const [error, setError] = useState(null);

  return (
    <form>
      <div>
        <div className="mt-3 text-start sm:mt-5">
          <p
            as="h3"
            className="text-center text-base font-normal leading-6 text-gray-800 family-didact"
          >
            Add cost amount
          </p>
          <div className="mt-2 space-y-4 grid grid-cols-2 gap-4">
            <NumberInputText
              label="Cost amount in percentage"
              name="quantity"
              onChange={(e) => {
                setAmount(e.target.value);
              }}
              value={amount}
              labelOn={true}
              suffix={`%`}
              error={error}
            />
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 flex items-center justify-center gap-3">
        <button
          type="button"
          className="inline-flex w-fit justify-center rounded-md bg-white px-3 py-2 text-sm font-light family-didact text-gray-900 shadow-sm hover:bg-gray-50 shadow-sm ring-1 ring-inset ring-gray-300"
          onClick={() =>
            setEmptyModelOpen({ childComponent: null, open: false })
          }
        >
          Cancel
        </button>
        <Button
          type="button"
          onClick={() => {
            if (parseFloat(amount) > 0.0) {
              createPriceGroup(amount);
            } else {
              setError("Amount must be over 0");
            }
          }}
        >
          OK
        </Button>
      </div>
    </form>
  );
}
